import logo from './logo_patrickm_smooth.svg';
import './App.css';
import IPCity from './IPCity';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Imported from <code>DsCore</code> component.
        </p>
        
        <a
          className="App-link"
          href="https://patrickm.consulting"
          target="_blank"
          rel="noopener noreferrer"
        >https://patrickm.consulting</a>
      </header>
      <IPCity/>
      <p>
        Try this application on &copy;Microsoft Edge browser !
      </p>
    </div>
  );
}

export default App;
